import { IHttpGetMethod } from '@/@core/@shared/domain/interfaces/IHttpClient.interface'
import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { IRecentFireRiskRepository } from '../../domain/repositories/IRecentFireRisk.repository'
import { RecentFireRisk } from '../../domain/entities/RecentFireRisk'
import { RecentFireRiskSchema } from './schemas/RecentFireRisk.schema'

function parseRecentFireRiskList(rawData: unknown): RecentFireRisk[] {
	if (!Array.isArray(rawData)) return []

	const items: RecentFireRisk[] = []
	rawData.forEach((item) => {
		const result = RecentFireRiskSchema.safeParse(item)
		if (result.success) items.push(result.data)
	})
	return items
}

export class RecentFireRiskRepositoryApiAdapter implements IRecentFireRiskRepository {
	private _endpoint = '/v1/dashboard-risco-de-incendio'

	constructor(private _httpClient: IHttpGetMethod) {}

	async getByMonitoredAreas(monitoredAreasIds: string[]): Promise<RecentFireRisk[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-informacoes-risco-de-incendio-mais-recentes`,
			{
				params: { idArea: monitoredAreasIds },
				paramsSerializer: {
					indexes: null,
				},
			},
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			return []
		}

		return parseRecentFireRiskList(response.data)
	}
}
